(ns frontend.view.components.power-search.sub
  (:require
   [re-frame.core :as rf]))

(rf/reg-sub ::open? (comp true? ::open?))

(rf/reg-sub
 ::main-view-hits-by-entity-type
 (fn [db]
   (::main-view-hits-by-entity-type db)))

(rf/reg-sub
 ::main-view-hit-totals-by-entity-type
 (fn [db]
   (::main-view-hit-totals-by-entity-type db)))

(rf/reg-sub
 ::loading?
 (fn [db]
   (not=
    (::query db)
    (if (::type-view-entity-type db)
      (::type-view-loaded-query db)
      (::main-view-loaded-query db)))))

(rf/reg-sub
 ::type-view-entity-type
 (fn [db]
   (::type-view-entity-type db)))

(rf/reg-sub
 ::type-view-hits
 (fn [db]
   (::type-view-hits db)))

(rf/reg-sub
 ::show-loading-text?
 (fn [db]
   (::show-loading-text? db)))

(rf/reg-sub
 ::query
 (fn [db]
   (::query db)))

(rf/reg-sub
 ::fuzzy?
 (fn [db]
   (::fuzzy? db)))

(rf/reg-sub
 ::from-index
 (fn [db]
   (::from-index db)))

(rf/reg-sub
 ::type-view-total-hits
 (fn [db]
   (::type-view-total-hits db)))

(rf/reg-sub
 ::recents
 (fn [db]
   (::recents db)))

(rf/reg-sub
 ::input-focused?
 (fn [db]
   (::input-focused? db)))

(rf/reg-sub
 ::search-all-fields?
 (fn [db]
   (::search-all-fields? db)))
